import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { SubSink } from "subsink";
import { LocalService } from "../../core/storage/local.service";
import { SessionService } from "../../core/storage/session.service";

@Component({
  selector: "app-auth0-login",
  templateUrl: "./auth0-login.component.html",
  styleUrls: ["./auth0-login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Auth0LoginComponent implements OnInit, OnDestroy  {
  auth0Error: string | null = null;
  private subs = new SubSink();


  private readonly localStorageKeysToClear: string[] = [
    "active_session",
    "refresh",
    "ng2Idle.main.expiry",
    "ng2Idle.main.idling",
  ];

  constructor(
    private readonly auth0: AuthService
  ) {
  }

  ngOnInit(): void {
    this.clearSessionState();

    this.subs.sink = this.auth0.error$.subscribe(err => {
      this.auth0Error = err?.message || null;
    });

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loginWithAuth0(event: Event): void {
    event.preventDefault();

    sessionStorage.setItem("auth_type", "auth0");

    this.auth0.loginWithRedirect({
      appState: {
        target: "login/select-user",
      },
    });
  }

  private clearSessionState(): void {
    this.localStorageKeysToClear.forEach(key => {
      localStorage.removeItem(key);
  });
  }
}
